module.exports = __webpack_public_path__ + "static/img/bookand-g.b07b921a.png";